const GLOBAL_KEY = 'cioanalytics';

export default function initializeCustomerIo(projectId, userId, traits) {
  const analytics = (window[GLOBAL_KEY] = window[GLOBAL_KEY] || []);

  if (analytics.initialize || analytics.invoked) {
    return;
  }

  analytics.invoked = true;
  analytics.methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
    'addSourceMiddleware',
    'addIntegrationMiddleware',
    'setAnonymousId',
    'addDestinationMiddleware',
  ];
  analytics.factory = function (e) {
    return function (...args) {
      analytics.push([e, ...args]);
      return analytics;
    };
  };
  analytics.methods.forEach(key => {
    analytics[key] = analytics.factory(key);
  });
  analytics.load = function (key, options) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('data-global-customerio-analytics-key', GLOBAL_KEY);
    script.src = `https://cdp.customer.io/v1/analytics-js/snippet/${key}/analytics.min.js`;
    const first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) {
      first.parentNode.insertBefore(script, first);
    } else {
      document.head.appendChild(script);
    }
    analytics._writeKey = key;
    analytics._loadOptions = options;
  };
  analytics.SNIPPET_VERSION = '4.15.3';

  analytics.load(projectId);
  analytics.identify(userId, traits);
  analytics.page();
}
